import { render, staticRenderFns } from "./JobFieldsTable.vue?vue&type=template&id=2768d8ca&"
import script from "./JobFieldsTable.vue?vue&type=script&lang=js&"
export * from "./JobFieldsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports